import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ payments }) => {
    const empty = (payments.length === 0);

    if (empty) {
        return (
            <div className="alert alert-warning rounded-0">
                Nenhum pagamento registrado para esta venda.
            </div>
        );
    }
    return (
        <table className="table align-items-center table-flush">
            <TableHead />
            <TableBody payments={payments} />
        </table>
    );
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Payments/Table.js